export const Plus = (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 19.034 19.038">
        <g id="组_77532" data-name="组 77532" transform="translate(-425.162 -3009.994)">
            <line
                id="直线_11"
                data-name="直线 11"
                x2="16.034"
                transform="translate(426.662 3019.513)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="3"
            ></line>
            <line
                id="直线_12"
                data-name="直线 12"
                y1="16.038"
                transform="translate(434.678 3011.494)"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="3"
            ></line>
        </g>
    </svg>
);
